import React from 'react';
import { Phone } from 'lucide-react';
import { trackCallClick } from '../utils/tracking';

const FloatingPhoneButton = () => {
  const phoneNumber = "09.70.70.70.69";
  const phoneHref = "tel:+33970707069";

  return (
    <a
      href={phoneHref}
      onClick={() => trackCallClick(window.location.pathname)}
      className="fixed bottom-6 right-6 z-50 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-full p-4 shadow-2xl hover:shadow-amber-500/50 hover:scale-110 transition-all duration-300 flex items-center gap-2 group"
      aria-label="Appeler le 09.70.70.70.69"
    >
      <Phone className="h-6 w-6 animate-pulse" />
      <span className="hidden md:inline-block font-semibold pr-2">
        {phoneNumber}
      </span>
    </a>
  );
};

export default FloatingPhoneButton;
